import Global from "../constants/global";
import PhonepeEvents from "./events.service";
import eventsMap from "../constants/eventsMap";

const JSEncrypt = typeof window !== "undefined" && require("../lib/jse.min").JSEncrypt;
const encrypt = JSEncrypt && new JSEncrypt();
const newCardEncrypt = JSEncrypt && new JSEncrypt();
encrypt && encrypt.setPublicKey(Global.PUBLIC_KEY);

/**
 * @desc  Encrypts data with PUBLIC KEY
 * @param data
 * @returns {*}
 */
const encryptWithPublicKey = data => (encrypt ? { encrypted: true, data: encrypt.encrypt(JSON.stringify(data)) } : { encrypted: false, data });
const newCardEncryptWithPublicKey = (key, data, dataType = "CARD_NUMBER") => {
  let eventData = {
    isEncryptionSuccess: false,
    encryptionRequestStatus: dataType,
  };

  if (newCardEncrypt) {
    newCardEncrypt.setPublicKey(key);
    const encrytptedObject = {
      encrypted: true,
      data: newCardEncrypt.encrypt(data),
    };

    if (encrytptedObject && encrytptedObject.data && encrytptedObject.data.length > 0) {
      eventData.isEncryptionSuccess = true;
    } else {
      eventData.encryptionRequestStatus = dataType + "_NULL";
    }
    PhonepeEvents.addEvent(eventsMap.CARD_ENCRYPTION_KEY, eventData);
    return encrytptedObject;
  } else {
    PhonepeEvents.addEvent(eventsMap.CARD_ENCRYPTION_KEY, eventData);
    return { encrypted: false, data };
  }
};

export { encryptWithPublicKey, newCardEncryptWithPublicKey };
